import { getCourseConfig as fetchCourseConfig } from '../admin';

// Cached course-config reader. Shared across student pages (PendingRatingsAlert,
// ArtifactItem, WorkAssessment) so multiple components rendered for the same
// course don't each hit Firestore. Course docs are world-readable per Firestore
// rules, so this is safe to call from non-admin contexts.

// AdminDataService.getCourseConfig 如果想统一缓存源，可让它 delegate 到 CourseConfigService


const TTL_MS = 5 * 60 * 1000; // 5 minutes
const cache = new Map(); // courseId -> { value, expiresAt }

export const getCourseConfig = async (courseId, forceRefresh = false) => {
    if (!courseId) return null;

    if (!forceRefresh) {
        const entry = cache.get(courseId);
        if (entry && entry.expiresAt > Date.now()) {
            return entry.value;
        }
    }

    const value = await fetchCourseConfig(courseId);
    cache.set(courseId, { value, expiresAt: Date.now() + TTL_MS });
    return value;
};

export const invalidateCourseConfig = (courseId) => {
    if (courseId) cache.delete(courseId);
    else cache.clear();
};
